import React__default from 'react';
import { PurchaseTypeSelectionBoxes } from '../../../components/PurchaseTypeSelectionBoxes/PurchaseTypeSelectionBoxes.js';
import { useProductData } from '../../../../../context/product-context-hooks.js';
import { useCLEcommContext } from '../../context/CLEcommContext.js';
import { updatePurchaseType } from '../../../../../context/actions.js';

const CLPurchaseTypeSelectionBoxes = ({ className  })=>{
    const { activeVariant: { purchaseTypePrices , isAvailableForSubscription  } , dispatch ,  } = useProductData();
    const { actions: actions$1 , state  } = useCLEcommContext();
    const { purchaseType  } = state.configurations;
    const handleSelection = React__default.useCallback((key)=>{
        actions$1.updatePurchaseType(key);
        dispatch(updatePurchaseType({
            purchaseType: key
        }));
    }, [
        actions$1
    ]);
    return /*#__PURE__*/ React__default.createElement(PurchaseTypeSelectionBoxes, {
        className: className,
        selectedPurchaseType: purchaseType,
        subscriptionTypeAllowed: isAvailableForSubscription,
        purchaseTypePrices: purchaseTypePrices,
        onSelection: handleSelection
    });
};

export { CLPurchaseTypeSelectionBoxes };
//# sourceMappingURL=CLPurchaseTypeSelectionBoxes.js.map
